import React, { useEffect, useRef, useState } from 'react';
import './Intro.css';
import docking_img from './intro_fig/docking.png'
import performance_img from './intro_fig/performance.jpg'
import datasets_img from './intro_fig/datasets.jpg'
import relaxation_img from './intro_fig/relaxation.jpg'

const IntroComponent = () => {
  const rowRefs = useRef([]);
  const [visibleRows, setVisibleRows] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const idx = Number(entry.target.getAttribute('data-row-index'));
          setVisibleRows((prev) => ({ ...prev, [idx]: entry.isIntersecting }));
        });
      },
      {
        // Trigger a bit earlier to avoid large blank gap before reveal.
        threshold: 0.12,
        rootMargin: '0px 0px 0% 0px',
      }
    );

    rowRefs.current.forEach((row) => {
      if (row) {
        observer.observe(row);
      }
    });

    return () => observer.disconnect();
  }, []);

  const sections = [
    {
      title: 'Self-Docking VS Cross-Docking',
      imgAlt: 'Self-Docking VS Cross-Docking',
      // TODO: 把图片文件放到 src/components/intro_fig 后，把这里改成真实路径即可
      // 例如：imgSrc: new URL('./intro_fig/xxx.png', import.meta.url).toString()
      imgSrc: docking_img,
      body: 'Self-docking involves docking a ligand back into its native co-crystallized conformation. This is typically used to assess whether the docking software accurately reproduces the known binding pose, thereby validating the method. Most existing benchmarks only consider the self-docking setup.Cross-docking refers to dock molecules extracted from distinct complexes of the same protein with all conformations except the native co-crystalized one. This approach is considered more versatile, as it accounts for the possibility that the receptor protein may undergo conformational changes and may not be fully optimized for ligand docking.',
    },
    {
      title: 'Performance',
      imgAlt: 'Performance',
      imgSrc: performance_img,
      body: 'AI-based approaches lead in success rate. The latest AI-based approaches, both AI docking methods(e.g., SurfDock) and AI co-folding methods (e.g., AlphaFold3) have consistently outperformed physics-based methods in overall docking pose and validity.Relaxation significantly mitigates clashing. The intra- and intermolecular clashes of AI-based approaches can be greatly alleviated with relaxation, which means that the force field-based energy minimization step is very crucial to achieve excellent performance in real-world applications, particularly for AI modeling.',
    },
    {
      title: 'Datasets',
      imgAlt: 'Datasets',
      imgSrc: datasets_img,
      body: 'we curated a high-quality protein-ligand complex structure dataset, PoseX, designed to evaluate molecular docking methods. It comprises carefully selected crystal structures from the RCSB Protein Data Bank (RCSB PDB), with two subsets for evaluating self-docking and cross-docking tasks. The dataset includes only complex structures published from 2022 to January 1st, 2025, ensuring no overlap with the training data of all AI-based approaches being evaluated',
    },
    {
      title: 'Relaxation',
      imgAlt: 'Relaxation',
      imgSrc: relaxation_img,
      body: 'Relaxation in molecular docking, also known as energy minimization, is a post-processing method used to refine and optimize docked protein-ligand complexes. It involves energy minimization and, when necessary, short molecular dynamics simulations to resolve steric clashes, refine interatomic interactions, and ensure that the system reaches a stable, low-energy conformation. This step enhances the physical realism and accuracy of the docking results, thereby making the predicted binding poses more reliable for subsequent analysis or experimental validation.',
    },
  ];

  return (
    <div className="intro-alt-page">
      <div className="intro-alt-container">
        {sections.map((s, idx) => {
          const isReversed = idx % 2 === 0; /* 第 1 行左文右图，之后交替 */
          return (
            <section
              key={s.title}
              ref={(el) => {
                rowRefs.current[idx] = el;
              }}
              data-row-index={idx}
              className={`intro-alt-row ${isReversed ? 'intro-alt-row--reverse' : ''} ${visibleRows[idx] ? 'is-visible' : ''}`}
            >
              <div className="intro-alt-media">
                {s.imgSrc ? (
                  <img className="intro-alt-image" src={s.imgSrc} alt={s.imgAlt} />
                ) : (
                  <div className="intro-alt-image-placeholder" aria-label={`${s.title} figure`} />
                )}
              </div>

              <div className="intro-alt-text">
                <div className="intro-alt-title-wrap">
                  <h2 className="intro-alt-title">{s.title}</h2>
                </div>
                <p className="intro-alt-body">{s.body || ''}</p>
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
};

export default IntroComponent;